/**
 * Accordion Efect on Footer Elements
 */
window.accordionFooter = function (myObj) {
    if ($(window).width() >= 575) {
        return;
    }
    $(myObj).find("h4").toggleClass("active");
    $(myObj).find("ul").slideToggle(200);
};
